import { ButtonPrimary } from '@/components/button'
import { Close } from '@/components/icons'
import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'

type Props = {
  open: boolean
  className?: string
  onClose: () => void
  onCloseButton?: () => void
  title: string
  desc: string
  onSubmit: (params?: any) => any
  cancelTitle?: string
  submitTitle?: string
  disableCancelBtn?: boolean
  buttonContainerClassName?: string
  submitButtonClassName?: string
  closeButtonClassName?: string
  disableSubmitBtn?: boolean
}

export const ConfirmModal = ({
  open,
  onClose,
  onCloseButton,
  title,
  desc,
  onSubmit,
  buttonContainerClassName,
  submitButtonClassName,
  closeButtonClassName,
  cancelTitle = 'Cancel',
  submitTitle = 'Submit',
  disableCancelBtn = false,
  disableSubmitBtn = false,
}: Props) => {
  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-[350px] transform overflow-hidden rounded-2xl bg-white px-6 py-4 text-left align-middle shadow-xl transition-all relative">
                <button
                  className="w-9 h-9 rounded-full bg-navy-900 bg-opacity-10 flex items-center justify-center ml-2 hover:bg-opacity-20 absolute right-2 top-2"
                  onClick={onClose}
                >
                  <Close className="text-navy-900" />
                </button>
                <Dialog.Title as="h3" className="text-xl text-navy-900 font-semibold">
                  {title}
                </Dialog.Title>
                <div className="mt-4">
                  <p className="text-sm text-navy-900 text-opacity-70">{desc}</p>
                </div>

                <div
                  className={`mt-6 flex items-center ${disableCancelBtn ? 'justify-start' : 'justify-end'} gap-x-4 ${
                    buttonContainerClassName ? buttonContainerClassName : ''
                  }`}
                >
                  {!disableCancelBtn && (
                    <button
                      type="button"
                      onClick={() => {
                        if (onCloseButton) onCloseButton()
                        if (!onCloseButton) onClose()
                      }}
                      className={`bg-navy-900 hover:bg-opacity-20 bg-opacity-10 rounded-full h-12 flex w-1/2 items-center justify-center text-navy-900 font-semibold ${
                        closeButtonClassName ? closeButtonClassName : ''
                      }`}
                    >
                      {cancelTitle}
                    </button>
                  )}

                  <ButtonPrimary
                    title={submitTitle}
                    disabled={disableSubmitBtn}
                    className={`h-12 flex items-center justify-center ${disableCancelBtn ? 'w-full' : 'w-1/2'} ${
                      submitButtonClassName ? submitButtonClassName : ''
                    }`}
                    onClick={onSubmit}
                  />
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}
